import type { ValuesContent } from "../types";

/**
 * 价值观：深色使命带（OpenAI 式对比色块）+
 * 编号原则清单（Anthropic 式 numbered values）。
 */
export function renderValues(values: ValuesContent): string {
  const principles = values.pillars
    .map(
      (p, i) => `
      <div class="principle" data-reveal style="--i:${i}">
        <span class="principle-no">${String(i + 1).padStart(2, "0")}</span>
        <div>
          <h3>${p.title}</h3>
          <p>${p.description}</p>
        </div>
      </div>`,
    )
    .join("");

  return `
    <section class="section values-section" id="${values.id}">
      <div class="values-band">
        <blockquote class="values-quote" data-reveal>
          ${values.quoteLead}<span class="accent">${values.quoteAccent}</span>
        </blockquote>
        <div class="principles">${principles}</div>
      </div>
    </section>`;
}
